// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#subtitle-2 {
  width: 100%;
  margin-top: 8px;
  margin-bottom: 2px;
}
#subtitle-2 #images-count-title,
#subtitle-2 #images-count-add {
  width: 100%;
  color: var(--ion-text-color);
}
#subtitle-2 #images-count-title {
  color: var(--text-Ttulos, #0D253A);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 4px;
}
#subtitle-2 #images-count-add {
  text-align: right;
}
#subtitle-2 #images-count-add ion-button {
  margin: 0px;
  text-transform: capitalize;
  --padding-start: 0px;
  --padding-end: 24px;
  font-size: 13px;
  font-weight: 500;
}
#subtitle-2 #images-count-add ion-button ion-icon {
  margin-right: 3px;
  width: 32px !important;
  height: 32px !important;
}
#subtitle-2 .rules p {
  color: var(--text-BODY, #2C4051);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0px;
  margin-top: 0px;
}

ion-list-header {
  padding-left: 5px;
}
ion-list-header ion-label {
  color: var(--text-Ttulos, #0D253A);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 0px;
  margin-top: 8px;
}

ion-list {
  background: #f8f9fb;
}
ion-list .gallery-item {
  --background: transparent;
  --padding-start: 8px;
  --padding-end: 8px;
}
ion-list ion-card {
  margin: 0;
  padding-top: 25px;
  margin-bottom: 0px;
  min-height: 180px;
  width: 100%;
  border-radius: 8px;
  z-index: 1;
  box-shadow: none;
}
ion-list ion-card ion-card-content div {
  margin-top: 32px;
  margin-bottom: 48px;
  max-height: 180px;
  font-size: 14px;
  font-weight: 500;
}
ion-list ion-card ion-card-content div.image {
  width: 100%;
  height: 180px;
  margin: 0;
  padding: 8px;
  background-size: contain;
  background-position: top;
  background-repeat: no-repeat;
  text-align: right;
}
ion-list ion-card ion-card-content div p {
  margin-top: 16px;
  margin-bottom: 16px;
}

#upsert-product-slider-container #no-product-images {
  background-color: #d1d1d1;
  height: 130px;
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0 16px;
  border-radius: 16px;
}
#upsert-product-slider-container #no-product-images ion-icon {
  height: 30px;
  width: 40px;
}
#upsert-product-slider-container #no-product-images div {
  position: relative;
  width: 100%;
  height: 130px;
  text-align: center;
}
#upsert-product-slider-container #no-product-images div img {
  width: auto;
  max-width: 100%;
  height: inherit;
  max-height: 100%;
}
#upsert-product-slider-container #no-product-images div ion-icon {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 8px;
  right: 8px;
  color: red;
  background: white;
  border-radius: 50%;
  box-shadow: 2px 2px 7px 2px grey;
}

.simple-header {
  font-size: 14px;
  font-weight: 500;
}

.remove-image-icon {
  margin: 0;
  position: absolute;
  top: 8px;
  right: 8px;
  background: #ffffff;
  box-shadow: 0px 0px 7px 2px black;
  border-radius: 50%;
  color: black;
  width: 24px;
  height: 24px;
}

ion-slides {
  height: 154px;
}
ion-slides ion-slide {
  overflow: hidden;
}
ion-slides .swiper-slide {
  background: lightgray;
  border-radius: 16px;
  height: 130px;
}
ion-slides .swiper-slide img {
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
}

boxx-content-divider {
  --boxx-content-divider-margin-bottom: 0;
}

ion-select.available {
  color: var(--ion-color-success);
}
ion-select.soldout {
  color: var(--ion-color-danger);
}

.error-feedback-wrapper {
  min-height: 18px;
  margin-top: 16px;
}
.error-feedback-wrapper .error-feedback {
  text-align: center;
}

#addOption {
  margin: 15px 0;
}

ion-card-content {
  padding: 10px 0px;
}

.status {
  font-size: 14px;
  top: 4px;
}

ion-toggle {
  --background: #dfdfdf !important;
  --background-checked: var(--ion-color-primary) !important;
  --handle-background: #9f9f9e !important;
  --handle-background-checked: #fff !important;
}

#container-images {
  margin-top: 8px;
}
#container-images .add-image {
  background: #FFF;
  filter: drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.15));
  width: 65px;
  height: 63px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
}
#container-images .add-image ion-icon {
  color: var(--ion-color-primary);
  width: 22px;
  height: 19px;
}
#container-images .add-image ion-label {
  color: var(--ion-color-primary);
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Montserrat";
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
#container-images ion-col img {
  width: 70px;
  height: 63px;
  object-fit: cover;
  object-position: center center;
  border-radius: 8px;
  filter: drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.15));
}
#container-images .pad-col {
  padding: 0px 5px;
}

.custom-form-product {
  padding: 0px;
  padding-top: 8px !important;
}
.custom-form-product .custom-item-form ::ng-deep .required-indicator .label-text::after {
  content: "*";
  transform: translate(-100%, 0);
  color: red !important;
  padding-left: 5px;
}
.custom-form-product .custom-item-form ::ng-deep .custom-input .label-text {
  color: #0D253A !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Roboto";
  font-size: 16px !important;
}
.custom-form-product .custom-item-form ::ng-deep .custom-input {
  color: #0D253A !important;
  font-family: "Poppins";
  font-size: 16px !important;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0px;
  bottom: 2px;
}
.custom-form-product .custom-item-form {
  border: 2px solid #ede9e9;
  margin-bottom: 16px;
}
.custom-form-product .custom-item-form .icon-select {
  margin-top: 10px;
  position: relative;
  top: 5px;
  width: 20px;
  height: 20px;
  color: var(--ion-color-primary);
}
.custom-form-product .custom-item-form .available {
  color: #099F69 !important;
}
.custom-form-product .custom-item-form .to-do {
  color: #D50000 !important;
}
.custom-form-product .c-textarea {
  min-height: 56px;
  height: auto;
}

.container-stock {
  border-radius: 16px;
  background: #FFF;
  min-height: 56px;
  border: 2px solid #ede9e9;
  margin-bottom: 24px;
  padding-top: 5px;
  padding-bottom: 3px;
}
.container-stock ion-item {
  box-shadow: none !important;
}
.container-stock .custom-item-form {
  border-radius: 16px;
  border: 1px solid #f6f6f6;
  background: #FFF;
  margin-bottom: 0px;
  --padding-start: 16px;
  --padding-end: 16px;
}
.container-stock .bb-none {
  border: 1px solid #ffffff !important;
  padding-top: 4px;
  padding-bottom: 3px;
  min-height: 47px;
  border-bottom: 1px solid #d3d0d0 !important;
  border-radius: 0px !important;
}
.container-stock ion-item:first-child {
  border-top-left-radius: 16px !important;
  border-top-right-radius: 16px !important;
}
.container-stock ion-item:last-child {
  border: none !important;
  border-bottom-left-radius: 16px !important;
  border-bottom-right-radius: 16px !important;
}

.mr-default {
  margin-right: 24px;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/store-core/lib/components/product-form/product-form.component.scss"],"names":[],"mappings":"AAAA;EAGE,WAAA;EACA,eAAA;EACA,kBAAA;AADF;AAGE;;EAEE,WAAA;EACA,4BAAA;AADJ;AAIE;EACE,kCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAFJ;AAKE;EACE,iBAAA;AAHJ;AAKI;EACE,WAAA;EACA,0BAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAHN;AAKM;EACE,iBAAA;EACA,sBAAA;EACA,uBAAA;AAHR;AASI;EACE,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAPN;;AAYA;EACE,iBAAA;AATF;AAWE;EACE,kCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AATJ;;AAaA;EACE,mBAAA;AAVF;AAYE;EACE,yBAAA;EACA,oBAAA;EACA,kBAAA;AAVJ;AAaE;EACE,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AAXJ;AAoBM;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EAkBA,eAAA;EACA,gBAAA;AAnCR;AAkBQ;EACE,WAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,wBAAA;EACA,wBAAA;EACA,4BAAA;EACA,iBAAA;AAhBV;AAmBQ;EACE,gBAAA;EACA,mBAAA;AAjBV;;AA4BE;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;AAzBJ;AA2BI;EACE,YAAA;EACA,WAAA;AAzBN;AA4BI;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AA1BN;AA4BM;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AA1BR;AA6BM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,gCAAA;AA3BR;;AAiCA;EACE,eAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,SAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AA9BF;;AAiCA;EAGE,aAAA;AAhCF;AAkCE;EACE,gBAAA;AAhCJ;AAmCE;EACE,qBAAA;EACA,mBAAA;EACA,aAAA;AAjCJ;AAmCI;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AAjCN;;AAsCA;EACE,uCAAA;AAnCF;;AAuCE;EACE,+BAAA;AApCJ;AAuCE;EACE,8BAAA;AArCJ;;AAyCA;EACE,gBAAA;EACA,gBAAA;AAtCF;AAwCE;EACE,kBAAA;AAtCJ;;AA0CA;EACE,cAAA;AAvCF;;AA0CA;EACE,iBAAA;AAvCF;;AA0CA;EACE,eAAA;EACA,QAAA;AAvCF;;AA0CA;EACE,gCAAA;EACA,yDAAA;EACA,uCAAA;EACA,4CAAA;AAvCF;;AA0CA;EACE,eAAA;AAvCF;AAyCE;EACE,gBAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAvCJ;AAyCI;EACE,+BAAA;EACA,WAAA;EACA,YAAA;AAvCN;AA0CI;EACE,+BAAA;EACA,kBAAA;EACA,6CAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAxCN;AA6CI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,kBAAA;EACA,oDAAA;AA3CN;AA+CE;EACE,gBAAA;AA7CJ;;AAmDA;EACE,YAAA;EACA,2BAAA;AAhDF;AAmDI;EACE,YAAA;EACA,8BAAA;EACA,qBAAA;EACA,iBAAA;AAjDN;AAoDI;EACE,yBAAA;EACA,6CAAA;EACA,qBAAA;EACA,0BAAA;AAlDN;AAqDI;EACE,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAnDN;AAwDE;EACE,yBAAA;EACA,mBAAA;AAtDJ;AAwDI;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;AAtDN;AAyDI;EACE,yBAAA;AAvDN;AA0DI;EACE,yBAAA;AAxDN;AA4DE;EACE,gBAAA;EACA,YAAA;AA1DJ;;AAgEA;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AA7DF;AA+DE;EACE,2BAAA;AA7DJ;AAgEE;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AA9DJ;AAiEE;EACE,oCAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2CAAA;EACA,6BAAA;AA/DJ;AAkEE;EACE,uCAAA;EACA,wCAAA;AAhEJ;AAmEE;EACE,uBAAA;EACA,0CAAA;EACA,2CAAA;AAjEJ;;AAsEA;EACE,kBAAA;AAnEF","sourcesContent":["#subtitle-2 {\n  // display: flex;\n  // align-items: center;\n  width: 100%;\n  margin-top: 8px;\n  margin-bottom: 2px;\n\n  #images-count-title,\n  #images-count-add {\n    width: 100%;\n    color: var(--ion-text-color);\n  }\n\n  #images-count-title {\n    color: var(--text-Ttulos, #0D253A);\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    margin-bottom: 4px;\n  }\n\n  #images-count-add {\n    text-align: right;\n\n    ion-button {\n      margin: 0px;\n      text-transform: capitalize;\n      --padding-start: 0px;\n      --padding-end: 24px;\n      font-size: 13px;\n      font-weight: 500;\n\n      ion-icon {\n        margin-right: 3px;\n        width: 32px !important;\n        height: 32px !important;\n      }\n    }\n  }\n\n  .rules {\n    p {\n      color: var(--text-BODY, #2C4051);\n      font-feature-settings: 'liga' off, 'clig' off;\n      font-family: 'Poppins';\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      margin-bottom: 0px;\n      margin-top: 0px;\n    }\n  }\n}\n\nion-list-header {\n  padding-left: 5px;\n\n  ion-label {\n    color: var(--text-Ttulos, #0D253A);\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    margin-bottom: 0px;\n    margin-top: 8px;\n  }\n}\n\nion-list {\n  background: #f8f9fb;\n\n  .gallery-item {\n    --background: transparent;\n    --padding-start: 8px;\n    --padding-end: 8px;\n  }\n\n  ion-card {\n    margin: 0;\n    padding-top: 25px;\n    margin-bottom: 0px;\n    min-height: 180px;\n    width: 100%;\n    border-radius: 8px;\n    z-index: 1;\n    box-shadow: none;\n    // margin: 0;\n    // margin-bottom: 2px;\n    // min-height: 180px;\n    // width: 100%;\n    // border-radius: 8px;\n    // z-index: 1;\n\n    ion-card-content {\n      div {\n        margin-top: 32px;\n        margin-bottom: 48px;\n        max-height: 180px;\n\n        &.image {\n          width: 100%;\n          height: 180px;\n          margin: 0;\n          padding: 8px;\n          background-size: contain;\n          background-position: top;\n          background-repeat: no-repeat;\n          text-align: right;\n        }\n\n        p {\n          margin-top: 16px;\n          margin-bottom: 16px;\n        }\n\n        font-size: 14px;\n        font-weight: 500;\n      }\n    }\n  }\n}\n\n#upsert-product-slider-container {\n  #no-product-images {\n    background-color: #d1d1d1;\n    height: 130px;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    margin: 0 16px;\n    border-radius: 16px;\n\n    ion-icon {\n      height: 30px;\n      width: 40px;\n    }\n\n    div {\n      position: relative;\n      width: 100%;\n      height: 130px;\n      text-align: center;\n\n      img {\n        width: auto;\n        max-width: 100%;\n        height: inherit;\n        max-height: 100%;\n      }\n\n      ion-icon {\n        width: 24px;\n        height: 24px;\n        position: absolute;\n        top: 8px;\n        right: 8px;\n        color: red;\n        background: white;\n        border-radius: 50%;\n        box-shadow: 2px 2px 7px 2px grey;\n      }\n    }\n  }\n}\n\n.simple-header {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.remove-image-icon {\n  margin: 0;\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: #ffffff;\n  box-shadow: 0px 0px 7px 2px black;\n  border-radius: 50%;\n  color: black;\n  width: 24px;\n  height: 24px;\n}\n\nion-slides {\n  //height: 100%;\n  //height: 160px;\n  height: 154px;\n\n  ion-slide {\n    overflow: hidden;\n  }\n\n  .swiper-slide {\n    background: lightgray;\n    border-radius: 16px;\n    height: 130px;\n\n    img {\n      width: 100%;\n      max-width: 100%;\n      height: 100%;\n      max-height: 100%;\n    }\n  }\n}\n\nboxx-content-divider {\n  --boxx-content-divider-margin-bottom: 0;\n}\n\nion-select {\n  &.available {\n    color: var(--ion-color-success);\n  }\n\n  &.soldout {\n    color: var(--ion-color-danger);\n  }\n}\n\n.error-feedback-wrapper {\n  min-height: 18px;\n  margin-top: 16px;\n\n  .error-feedback {\n    text-align: center;\n  }\n}\n\n#addOption {\n  margin: 15px 0;\n}\n\nion-card-content {\n  padding: 10px 0px;\n}\n\n.status {\n  font-size: 14px;\n  top: 4px;\n}\n\nion-toggle {\n  --background: #dfdfdf !important;\n  --background-checked: var(--ion-color-primary) !important;\n  --handle-background: #9f9f9e !important;\n  --handle-background-checked: #fff !important;\n}\n\n#container-images {\n  margin-top: 8px;\n\n  .add-image {\n    background: #FFF;\n    filter: drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.15));\n    width: 65px;\n    height: 63px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-radius: 8px;\n\n    ion-icon {\n      color: var(--ion-color-primary);\n      width: 22px;\n      height: 19px;\n    }\n\n    ion-label {\n      color: var(--ion-color-primary);\n      text-align: center;\n      font-feature-settings: 'clig' off, 'liga' off;\n      font-family: 'Montserrat';\n      font-size: 10px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n  }\n\n  ion-col {\n    img {\n      width: 70px;\n      height: 63px;\n      object-fit: cover;\n      object-position: center center;\n      border-radius: 8px;\n      filter: drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.15));\n    }\n  }\n\n  .pad-col {\n    padding: 0px 5px;\n  }\n}\n\n\n//Nuevo\n.custom-form-product {\n  padding: 0px;\n  padding-top: 8px !important;\n\n  .custom-item-form {\n    ::ng-deep .required-indicator .label-text::after {\n      content: '*';\n      transform: translate(-100%, 0);\n      color: red !important;\n      padding-left: 5px;\n    }\n\n    ::ng-deep .custom-input .label-text {\n      color: #0D253A !important;\n      font-feature-settings: \"liga\" off, \"clig\" off;\n      font-family: \"Roboto\";\n      font-size: 16px !important;\n    }\n\n    ::ng-deep .custom-input {\n      color: #0D253A !important;\n      font-family: \"Poppins\";\n      font-size: 16px !important;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      margin-bottom: 0px;\n      bottom: 2px;\n    }\n\n  }\n\n  .custom-item-form {\n    border: 2px solid #ede9e9;\n    margin-bottom: 16px;\n\n    .icon-select {\n      margin-top: 10px;\n      position: relative;\n      top: 5px;\n      width: 20px;\n      height: 20px;\n      color: var(--ion-color-primary);\n    }\n\n    .available{\n      color: #099F69 !important;\n    }\n\n    .to-do{\n      color: #D50000 !important;\n    }\n  } \n\n  .c-textarea {\n    min-height: 56px;\n    height: auto;\n  }\n\n}\n\n\n.container-stock {\n  border-radius: 16px;\n  background: #FFF;\n  min-height: 56px;\n  border: 2px solid #ede9e9;\n  margin-bottom: 24px;\n  padding-top: 5px;\n  padding-bottom: 3px;\n\n  ion-item {\n    box-shadow: none !important;\n  }\n\n  .custom-item-form {\n    border-radius: 16px;\n    border: 1px solid #f6f6f6;\n    background: #FFF;\n    margin-bottom: 0px;\n    --padding-start: 16px;\n    --padding-end: 16px;\n  }\n\n  .bb-none {\n    border: 1px solid #ffffff !important;\n    padding-top: 4px;\n    padding-bottom: 3px;\n    min-height: 47px;\n    border-bottom: 1px solid #d3d0d0 !important;\n    border-radius: 0px !important;\n  }\n\n  ion-item:first-child {\n    border-top-left-radius: 16px !important;\n    border-top-right-radius: 16px !important;\n  }\n\n  ion-item:last-child {\n    border: none !important;\n    border-bottom-left-radius: 16px !important;\n    border-bottom-right-radius: 16px !important;\n  }\n\n}\n\n.mr-default{\n  margin-right: 24px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
